import { styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
import { TrackMouseMove } from "../../TrackMouseMove.js";
const HueBox = styled(TrackMouseMove, {
  name: colorPickerName,
  overridesResolver: (_props, styles) => [styles.hue],
  slot: "Hue"
})(({ theme }) => ({
  backgroundImage: `linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%,
    #0ff 50%, #00f 67%, #f0f 83%, #f00 100%)`,
  borderRadius: theme.spacing(0.5),
  boxShadow: "inset 0 1px 1px 0.5px #0003",
  height: "100%",
  position: "relative",
  userSelect: "none",
  width: "100%"
}));
export {
  HueBox
};
//# sourceMappingURL=HueBox.js.map
